/**
 * @generated SignedSource<<9e5d918f41534616cb22fe4e9b7144e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalLinkedContent_signal$data = {
  readonly descriptionFiles: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
    readonly type: FileType | null;
    readonly url: string;
    readonly " $fragmentSpreads": FragmentRefs<"LinkedContentInput_files">;
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"LinkedContentInput_images">;
  }>;
  readonly id: string;
  readonly " $fragmentType": "WorkspaceSignalLinkedContent_signal";
};
export type WorkspaceSignalLinkedContent_signal$key = {
  readonly " $data"?: WorkspaceSignalLinkedContent_signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalLinkedContent_signal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceSignalLinkedContent_signal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedContentInput_images"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedContentInput_files"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SignalWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "bec5d4802fea5ca4cc42c8ae55875efe";

export default node;
